import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryKey } from '../gen/fileGW'

export const useInvalidateStorageInfo = () => {
    const queryClient = useQueryClient()

    return useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryKey(),
        })
    }, [queryClient])
}
